import handleTypedSearch from './handle-typed-search';
import handleCheckedAllBtn from './handle-checked-all-btn';
import handleAlphabetSearch from './handle-alphabet-search';

export {handleTypedSearch, handleCheckedAllBtn, handleAlphabetSearch};